import { ArticleHeading4, ArticleParagraph3 } from '@cian/ui-kit';

import { type FC, type ReactNode } from 'react';

import styles from './AuthorLabel.css';

export interface IAuthorLabelProps {
  label?: string | null;
  logoIcon: ReactNode;
  logoUrl?: string | null;
  name: string;
}

export const AuthorLabel: FC<IAuthorLabelProps> = ({ label, logoIcon, logoUrl, name }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['logo']}>
        {logoUrl ? (
          <img alt={name} className={styles['logo-image']} src={logoUrl} />
        ) : (
          <div className={styles['logo-icon']}>{logoIcon}</div>
        )}
      </div>
      <div className={styles['content']}>
        {label && <ArticleParagraph3 color="gray60_100">{label}</ArticleParagraph3>}
        <ArticleHeading4>
          <span className={styles['nowrap-text']}>{name}</span>
        </ArticleHeading4>
      </div>
    </div>
  );
};
